import { CookieOptions, Options, RestApiOptions } from '@sheerid/jslib';

const restOptions: RestApiOptions = {
    serviceUrl: "https://services.sheerid.com/",
    resources: {
        verification: "rest/v2/verification/",
        program: {
        base: "rest/v2/program/",
        theme: "theme",
        organization: "organization",
        },
        conversion: {
        base: "rest/v2/conversion/",
        },
    },
};

const cookieOptions: CookieOptions = {
    enabled: true,
    secure: true, // default: true - use with https://
    expires: 7, // default: 7 days
};

const defaultOptions: Options = {
    restApi: restOptions,
    mockStep: undefined,
    mockSubSegment: undefined,
    mockErrorId: undefined,
    doFetchTheme: true,
    logLevel: "error",
    locale: null,
    messages: {} /** @deprecated */,
    messagesWithLocale: {},
    urlStudentFaq: "https://verify.sheerid.com/student-faq/", // defaults
    urlSeniorFaq: "https://verify.sheerid.com/us-senior-faq/",
    urlMilitaryFaq: "https://verify.sheerid.com/military-faq/",
    urlTeacherFaq: "https://verify.sheerid.com/us-teacher-faq/",
    urlFirstResponderFaq: "https://verify.sheerid.com/first-responder-faq/",
    urlMedicalFaq: "https://verify.sheerid.com/us-medical-faq/",
    cookies: cookieOptions,
    useFingerprinting: false,
  };

let options = { ...defaultOptions };

export const getOptions = (): Options => options;
